import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/button';
import { Col, Row } from 'components/grid';

const ItemContainer = styled(Row)`
  height: 48px;
  border: 1px solid ${({ theme }) => theme.colors.gray300};
  border-radius: 4px;
  margin-bottom: 4px;
  align-items: center;
  padding-left: 16px;
  ${({ theme }) => theme.typograph.paragraphRegular}
`;

const ColButton = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

const List = ({
  Header, items, onSelect, renderContent, selectLabel, className,
}) => (
  <div className={className}>
    {Header && <Header />}
    {items.map((item) => (
      <ItemContainer key={item.field}>
        {renderContent(item)}
        <ColButton col={2}>
          <Button variant="link" onClick={() => onSelect(item)}>{selectLabel}</Button>
        </ColButton>
      </ItemContainer>
    ))}
  </div>
);

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  onSelect: PropTypes.func.isRequired,
  renderContent: PropTypes.func.isRequired,
  Header: PropTypes.func,
  selectLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
};

List.defaultProps = {
  className: null,
  Header: null,
};

export default List;
